import axios from "axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @returns {function(*): Promise<AxiosResponse<any> | never>}
 */
export function fetchOrganization(
  page = 1,
  ipp = 50,
  name = "",
  email = "",
  sort,
  direction
) {
  return function (dispatch) {
    const queryData = {
      page,
      ipp,
      name,
      email,
      order: sort,
      order_direction: direction,
    };
    dispatch({ type: "ORGANIZATIONS_FETCH", payload: queryData });

    const url =
      "/api/organizations.json?" + AxiosConfig.objectToURLQuery(queryData);

    return axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATIONS_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATIONS_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @returns {function(*): Promise<AxiosResponse<any> | never>}
 */
export function deleteOrganization(uuid) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_DELETE" });

    const url = "/api/organizations/" + uuid + ".json";

    return axios
      .delete(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_DELETE_FULFILLED",
          payload: { uuid },
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_DELETE_REJECTED",
          payload: error,
        });
      });
  };
}
